import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { PrimaryButton } from '@/Button';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';
import useLoginAndSaveSearch from '~/hooks/useLoginAndSaveSearch';
import SimilarResultsSection from './SimilarResults/SimilarResultsSection';
import {
  CtaWrapper,
  NoResultsWrapper,
  NotifyButton,
  SubTitle,
  Title
} from '../ResultSearchRedesign/ZeroResultSearch.styles';

export default function ZeroResultsSection() {
  const isInExperiment = useCheckExperimentBucket(
    'srch-impossible-facets',
    'experiment'
  );
  const handleSaveSearch = useLoginAndSaveSearch();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    trackEvent('Zero Results Shown');

    datadogRum.addAction('Zero Results Shown');
  }, [trackEvent]);

  return (
    <>
      {isInExperiment ? (
        <div className="bg-white flex flex-col gap-16 items-center justify-center mb-16 p-24 m:gap-24">
          <div className="flex flex-col gap-8 items-center justify-center m:gap-12">
            <div className="text-blue-7 tl-header-m m:tl-header-xl">
              No exact matches
            </div>
            <div className="text-blue-7 text-center tl-body-m m:tl-body-l">
              Save your search to get notified when more matches are available.
            </div>
          </div>
          <PrimaryButton
            className="!h-[40px] !min-h-[40px] max-w-[300px] w-full"
            data-analytics-id="zero results notify me button"
            onClick={handleSaveSearch}
          >
            Save Search
          </PrimaryButton>
        </div>
      ) : (
        <NoResultsWrapper>
          <Title>We didn’t find any exact matches</Title>
          <SubTitle>
            We get more cars every day. Get notified when the one you’re looking
            for is available.
          </SubTitle>
          <CtaWrapper>
            <NotifyButton
              data-analytics-id="zero results notify me button"
              onClick={handleSaveSearch}
            >
              Email me when available
            </NotifyButton>
          </CtaWrapper>
        </NoResultsWrapper>
      )}
      <SimilarResultsSection />
    </>
  );
}
